import { FC, useState } from 'react';
import styled, { css } from 'styled-components';
import Image from 'react-bootstrap/Image';
import { useLanguageContext } from 'store/language';

import flagBg from 'assets/flag-bg.svg';
import flagUsa from 'assets/flag-usa.svg';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import API from 'core/Api';
import { getAccessToken } from 'utils/auth';

interface LanguageSwitchProps {
  theme?: 'light' | 'dark';
  className?: string;
  onSelect?: () => void;
}

const LanguageSwitch: FC<LanguageSwitchProps> = ({ theme = 'dark', className, onSelect }) => {
  const [showOptions, setShowOptions] = useState(false);
  const { language, setLanguage } = useLanguageContext();
  const isUserLoggedIn = getAccessToken();

  const handleLanguageSelect = (lang: string) => {
    if (isUserLoggedIn) API.patch('auth/me', { lang });
    setLanguage(lang);

    if (onSelect) onSelect();
  };

  const renderSelectedLang = () => {
    return (
      <div className="d-flex align-items-center pt-2 pb-2">
        <Image
          src={language === 'en' ? flagUsa : flagBg}
          width={17}
          className="mr-1"
          alt={language?.toUpperCase() || 'BG'}
        />
        <span className="font-weight-bold">{language?.toUpperCase() || 'BG'}</span>
        {showOptions ? <FaAngleUp /> : <FaAngleDown />}
      </div>
    );
  };
  return (
    <Switch
      className={`${className} m-auto`}
      theme={theme}
      onClick={() => setShowOptions(!showOptions)}
    >
      {renderSelectedLang()}
      {showOptions && (
        <Options>
          <Option onClick={() => handleLanguageSelect('bg')}>
            <Image
              src={flagBg}
              width={17}
              className="mr-1"
              alt="BG"
            />
            BG
          </Option>
          <Option onClick={() => handleLanguageSelect('en')}>
            <Image
              src={flagUsa}
              width={17}
              className="mr-1"
              alt="EN"
            />
            EN
          </Option>
        </Options>
      )}
    </Switch>
  );
};

export default LanguageSwitch;

const Switch = styled.div`
  width: 60px;
  position: relative;
  cursor: pointer;

  ${props =>
    props.theme === 'dark' &&
    css`
      color: #575962;
    `}

  ${props =>
    props.theme === 'light' &&
    css`
      color: #ffffff;
    `}
`;

const Options = styled.div`
  position: absolute;
  top: 100%;
  color: #575962;
  background: ${props => props.theme.colors.white};
  box-shadow: ${props => props.theme.boxShadow};
  border-radius: ${props => props.theme.borderRadius};
`;
const Option = styled.div`
  display: flex;
  padding: 0.5rem;
  cursor: pointer;
  transition: 0.3s ease;

  &:hover {
    background: #fafafa;
  }
`;
